import { GET_TENANT_SETTINGS } from './gql';
export const getTenantsSettingsQuery = (gqlInstance) => {
    return gqlInstance
        .getClient('graphqlClient')
        .query({ query: GET_TENANT_SETTINGS })
        .then((response) => response.data.tenants);
};
//# sourceMappingURL=tenant.queries.js.map